import React, { useEffect, useContext } from 'react'
import { VStack, Heading, Text, Box, useColorMode } from '@chakra-ui/react'
import { getTokens } from '../config/colorTokens'
import { motion, AnimatePresence } from 'framer-motion'
import Section from '../components/Section'
import { education } from '../data/education'
import EducationItem from '../components/Education/EducationItem'
import Loader from '../components/Loader/Loader'
import loaderContext from '../context/loaderContext'
import SEOHead from "../components/SEOHead";
import { pageVariants, containerVariants, itemVariants, heroVariants } from '../config/animations'

const MotionVStack = motion(VStack)
const MotionBox = motion(Box)

const Education = () => {
    const context = useContext(loaderContext)
    const { loading, setLoading } = context
    const { colorMode } = useColorMode()
    const t = getTokens(colorMode)

    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 1500)
    }, [setLoading])
    return (
        <div>
            <SEOHead 
                title="Education | Prasoon Soni"
                description="Educational background of Prasoon Soni - Academic qualifications, degrees, and institutions that shaped a career in software engineering."
                path="/education"
            />
            <AnimatePresence>
                {loading ? <Loader key="loader" /> : <MotionVStack
                    key="content"
                    variants={pageVariants}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    spacing={0}
                    w="100%"
                    minH="100vh"
                >
                <Section id="education">
                    <VStack align="stretch" spacing={4} p={4}>
                        <MotionBox variants={heroVariants}>
                            <VStack align="start" spacing={3} mb={4}>
                                <Heading w="full">Education</Heading>
                                <Text
                                    fontSize={{ base: "md", md: "lg" }}
                                    color={t.textSubtle}
                                    fontWeight="light"
                                    maxW="2xl"
                                >
                                    The foundation of my engineering journey.
                                </Text>
                                <Box
                                    h="2px"
                                    w="60px"
                                    bgGradient={t.accentGradient}
                                    borderRadius="full"
                                    mt={1}
                                />
                            </VStack>
                        </MotionBox>
                        <MotionVStack
                            align="stretch"
                            spacing={4}
                            variants={containerVariants}
                        >
                            {education.map((edu) => {
                                return (
                                    <EducationItem
                                        key={edu.id}
                                        logo={edu.logo}
                                        name={edu.name}
                                        degree={edu.degree}
                                        stream={edu.stream}
                                        date={edu.date}
                                        location={edu.location}
                                        grade={edu.grade}
                                        variants={itemVariants}
                                    />
                                )
                            })}
                        </MotionVStack>
                    </VStack>
                </Section>
                </MotionVStack>}
            </AnimatePresence>
        </div >
    )
}

export default Education
